import {Injectable} from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {Alerta} from '../_models/alerta';

@Injectable({
  providedIn: 'root'
})
export class AlertaService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/alertas';

  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) {
  }

  listado() {
    return this.httClient.get(this.rutServicio).pipe(map(res => res as Alerta[]));
  }

  listadoHabilitados() {
    return this.httClient.get(this.rutServicio + '/enabled').pipe(map(res => res as Alerta[]));
  }

  obtenerPorId(id: string) {
    return this.httClient.get(this.rutServicio + '/' + id).pipe(map(res => res as Alerta));
  }

  alertaProducto(id: string) {
    return this.httClient.get( this.rutServicio + '/verificarProductos/' + id ).pipe( map( res => res as any[] ) );

  }

  crear(regCrear: Alerta) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post(this.rutServicio, regCrear).pipe(map(res => res as Alerta));
  }

  actualizar(regActualizar: Alerta) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post(this.rutServicio, regActualizar).pipe(map(res => res as any));
  }
}
